import { Component, ViewChild } from '@angular/core';
import { NavController, IonInfiniteScroll, LoadingController } from '@ionic/angular';
import { ResultProvider } from '../../../providers/result/result';
import { LoaderProvider } from '../../../providers/loader/loader';
import { EventProvider } from '../../../providers/event/event';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';

/**
 * Generated class for the ResoultRanglistPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
    selector: 'page-result-total',
    templateUrl: 'result-total.html',
    styleUrls:['./result-total.scss']
})
export class ResultTotalPage {
    @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;
    currentPage = 1;
    EVENTS_PER_PAGE = 25;

    eventType = "";
    eventArea = "";
    events = [];

    constructor(public navCtrl: NavController,
        public router:Router,
        public eventService: EventProvider,
        public resultService: ResultProvider,
        public loadingCtrl: LoadingController,
        public translate: TranslateService
    ) {
        const nav = this.router.getCurrentNavigation();
        const state = nav?.extras?.state || {};
        this.eventType = state['eventType'];
        this.eventArea = state['events'].category;
        this.events = Object.assign([], state['events'].event);
    }

    arrayOf(n?: number) {
        return this.events.slice(0, this.EVENTS_PER_PAGE * this.currentPage);
    }

    loadNextPage(event: IonInfiniteScroll) {
        this.currentPage++;
        event.complete();
    }
    onEventLoad(event: any) {
        console.log('Event clicked:', event);
    }
}
